let _  = {
  debounce: require('lodash/debounce')
}

window.TransferForm = {
  animationDuration: 500,
  isDateToOk: null,
  EVENT_ROUTE_UPDATED: 'route_updated',
  DEFAULT_CAR_RENTAL_LINK: 'https://www.autorentals.com/remotesearch?cid=89000&utm_source=gettransfer&utm_campaign=89000',
  CAR_RENTAL_DAYS_DURATION: 7,

  init: function() {
    this.$form = $('#new-transfer-form, #transfer-form, #short-transfer-form');
    this.$transportType = this.$form.find('.table-transport-type');
    this.bookNowTypes = [];
    this.formId = this.$form.attr('id')
    if (!this.formId) return;

    if (this.formId !== 'transfer-form') this.initPoints(this.formId)

    this.changeTransferType();
    this.swapLocations();
    this.skipIframeOnShortForm();
    this.changeCurrencyEvent();

    this.$form.on('transfer_type_changed', () => {
      try { window.fbq('track', 'ViewContent') } catch (e) {}
    })

    this.$form.find('#delivery').click(() => {
      try { gtag('event', 'delivery', { event_category: 'tab' }) } catch (e) {}
    });

    this.$form.find('.gettransport-opener').on('click', function(event) {
      event.preventDefault();
      try {
        gtag('event', 'delivery', {
          event_category: 'type',
          event_label: 'cargo'
        });
      } catch (e) {}

      window.open(
        'https://gettransport.com?utm_source=gettransfer&utm_medium=referal&utm_campaign=delivery',
        '_blank',
      );
    })

    $('#car-rental').click(() => this.carRental());

    if (this.formId === 'short-transfer-form') return this.formId

    this.promoCodeChange();
    this.transportTypeChange();

    if (this.formId === 'transfer-form') return this.formId

    this.$requiredInputs = this.$form.find('#email, #phone');
    this.$isIframe = this.$form.find('[name="iframe"]').val() === 'true';
    this.additionalOptionsShowHide();
    this.validation();
    this.returnWayShowHide();
    this.changeTransferType();

    this.$requiredInputs.on('blur', function() {
      var $this = $(this);
      if ($this.hasClass('show-error') && $this.val()) {
        TransferForm.clearInputErrors();
      }
    })

    window.addEventListener('pax.changed', () => this.updateRoute());

    try { window.fbq('track', 'AddToCart') } catch (e) {}

    return this.formId
  },

  initPoints () {
    this.points = {
      from: new RoutePoint('from'),
      to: new RoutePoint('to')
    }

    window.queue.afterMapsLoaded(() => {
      if (this.formId === 'new-transfer-form') {
        this.gmap = new GMap('gmap')
        this.gmap.updatedMarkerPosition = (key, position) => {
          this.points[key].position = [position.lat(), position.lng()]
        }
      }
    });

    for (let key in this.points) {
      this.points[key].updatedPosition = position => {
        window.queue.afterMapsLoaded(() => {
          if (this.gmap) this.gmap.setMarker(key, position)
        });
        this.$form.trigger('point_changed')
      }
      window.queue.afterMapsLoaded(() => {
        if (this.gmap && this.points[key].position)
          this.gmap.setMarker(key, this.points[key].position)
      });
    }

    $('#date, #time, #date_return, #time_return, #date_end, #time_end')
      .blur(() => this.$form.trigger(this.isHourly() ? 'duration_changed' : 'point_changed'))

    this.$form.bind('transfer_type_changed point_changed points_inited duration_changed', () => {
      this.updateRoute()
    })

    this.$form.trigger('points_inited')
  },

  updateRoute: _.debounce(() => {
    const self = TransferForm
    if (self.gmap) {
      self.gmap.clearRoute()
      self.clearRouteInfo()
    }
    self.hideTransportTypePrice(self.transportTypesElements())
    new Route({
      positionFrom: TransferForm.pointPositions()[0],
      positionTo: TransferForm.pointPositions()[1],
      withPrices: true,
      returnWay: $('#return_way').prop('checked'),
      dateTo: self.getDate(),
      dateReturn: self.getDateReturn(),
      hourlyDateEnd: self.getHourlyDateEnd(),
      pax: $('input[name="transfer[pax]"]').val(),
      countries: [self.points.from.country, self.points.to.country],
      hourly: self.isHourly(),
      delivery: self.currentTransferType() === 'delivery',
    })
      .getInfo(info => {
        $('.water-taxi-route').toggleClass('visible', info.watertaxi === true)
        window.queue.afterMapsLoaded(() => {
          if (self.gmap && !self.isHourly() && info.success) {
            self.gmap.setRoute(info)
          }
        });

        if (info.prices) {
          self.setTransportTypesPrices(info.prices)
        }

        self.isDateToOk = info.date_to_ok

        if (info.asap_possible) {
          $('#asap_block').show(self.animationDuration);
        } else {
          $('#asap_block').hide(self.animationDuration);
          $('#asap_checkbox').prop('checked', false).trigger('change')
        }
        window.dispatchEvent(new CustomEvent(self.EVENT_ROUTE_UPDATED, { detail: info }))
      })
  }),

  getLatLng () {
    return MapRoutes.getPositionsLatLng(this.points.from, this.points.to)
  },

  pointPositions () {
    return [
      this.points['from'].positionPoint,
      this.points['to'].positionPoint
    ]
  },

  isAllPoints () {
    return !!this.pointPositions().reduce((acc, p) => acc && p, true)
  },

  forgetPoints () {
    ['from', 'to'].forEach(key => new RoutePoint(key).forget());
  },

  clearRouteInfo () {
    $('#route_time, #route_distance, #route_speed').text('');
    MapRoutes.routeInfo = {};
    $('.double').toggleClass('show-double', false);
  },

  promoCodeChange: function() {
    $('#promo_code').on('change', function () {
      var $this = $(this),
          $resultMsg = $this.find('~ #promo_code_result'),
          value = $.trim($this.val())
      if (!value) {
        $resultMsg.addClass('hide')
        return true
      }
      $.ajax({
        url: '/api/promo_codes/search',
        data: { value: $this.val() },
        success: function(res) {
          $resultMsg.text(res.data)
          $resultMsg.removeClass('hide error').addClass('success')
        },
        error: function(res) {
          $resultMsg.text(res.responseJSON.error.details)
          $resultMsg.removeClass('hide success').addClass('error')
        }
      })
    }).trigger('change')
  },

  transportTypeChange: function() {
    const $checkboxes = this.$transportType.find('input[type="checkbox"]');
    $checkboxes.click(() => {
      const transportTypes = [];

      $checkboxes.each((_, el) => {
        if (el.checked) transportTypes.push(el.value);
      });

      window.dispatchEvent(new CustomEvent('transportType.change', {
        detail: transportTypes,
      }));
    });
    $checkboxes.trigger('change');
  },

  additionalOptionsShowHide: function() {
    var self = this,
        $additionalOptions = $('.additional-options input[type="checkbox"]'),
        $airlineOptions = $('.airline-options input[type=radio]');
    $additionalOptions.add($airlineOptions).on('change', function() {
      var $this = $(this);
      var $hiddenField = $this.closest('.control-label').next('.hidden-field');
      if ($this.prop('checked')) {
        $hiddenField.show(self.animationDuration);
        if ($this.is($airlineOptions)) {
          $airlineOptions.filter(':not(:checked)').trigger('change');
        }
      } else {
        $hiddenField.hide(self.animationDuration);
        $hiddenField.find('input').val('');
      }
      $hiddenField.find('#promo_code_result').text('');
    }).trigger('change');
    $(this.$form).on('point_changed', function () {
      if (self.points.from.types === null && self.points.to.types === null) return
      let checkTypes = function (types) {
        if (!types) return false
        return types.includes('airport') || types.includes('train_station')
      }
      let checked = checkTypes(self.points.from.types) ||
        (checkTypes(self.points.to.types) && $('#return_way').is(':checked'))
      $('#flight-number-checkbox, #name_sign_checkbox').each(function() {
        if (!$(this).closest('.form-group').find('.form-control').val()) {
          $(this).prop('checked', checked).trigger('change')
        }
      })
    })
  },

  clearInputErrors: function() {
    $('.js-error-email-phone-null').addClass('hide');
    TransferForm.$requiredInputs
      .removeClass('show-error')
      .attr('required', false);
  },

  checkRequiredFields: function() {
    var $requiredInputs = TransferForm.$requiredInputs
    var isBookNowPossible = TransferForm.bookNowTypes.length && this.currentTransferType() === 'one_way';
    if ((isBookNowPossible && !TransferForm.$isIframe) || !$requiredInputs.length) return true

    var errorInputs = []

    $requiredInputs.each(function() {
      var $this = $(this)
      if (!$this.val()) {
        errorInputs.push($this)
      }
    });

    var hasManyErrors = errorInputs.length > 1

    errorInputs.forEach(function(input) {
      input
        .toggleClass('show-error', hasManyErrors)
        .attr('required', hasManyErrors)
    })
    $('.js-error-email-phone-null').toggleClass('hide', !hasManyErrors)

    return errorInputs.length < $requiredInputs.length
  },

  isHourly: function() {
    return this.$form.hasClass('hourly');
  },

  currentTransferType: function() {
    return $('.switcher input:checked').attr('id');
  },

  hourlyInputs: function() {
    return $('#date, #time, #date_end, #time_end');
  },

  validation: function() {
    Date.prototype.addHours = function(hours) {
      this.setHours(this.getHours() + hours);
      return this;
    };

    var self = this

    const $date_to = self.$form.find('#date');
    const $time_to = self.$form.find('#time');
    const $date_end = self.$form.find('#date_end');
    const $time_end = self.$form.find('#time_end');

    var $date_return = function(required) {
      required = (typeof required !== 'undefined' ? required : true);
      var $elem = self.$form.find('#date_return');
      return (required ? $elem.filter('[required]') : $elem);
    };

    var $time_return = this.$form.find('#time_return'),
        $inputs_return = $date_return(false).add($time_return),
        $transport_type = this.$transportType;

    const ERROR_CLASS = 'show-error';

    function is_date_return_valid() {
      if ($date_return().length < 1) {
        $inputs_return.removeClass(ERROR_CLASS);
        return true;
      }
      return TransferForm.getDateReturn() >= TransferForm.getDate()
    }

    function isHourlyDateValid () {
      if (!self.hourlyInputs().filter('[required]').length) return true;
      return self.getHourlyDateEnd() >= self.getDate();
    }

    function transportTypePresenceCheck()
    {
      var valid = true;
      var $transport_type_input = $transport_type.find('input');

      if (!$transport_type_input.filter(':checked').val()) {
        valid = false;
        $transport_type.parent().addClass(ERROR_CLASS);
      }

      $transport_type.find('input').on('change.presence', function() {
        if ($transport_type_input.filter(':checked').val()) {
          $transport_type.parent().removeClass(ERROR_CLASS).find('input').off('change.presence');
        }
      });

      return valid;
    }

    this.$form.on('submit', event => {
      var valid = true;
      const setInputError = $input => {
        $input.addClass(ERROR_CLASS);
        valid = false;
      }
      const adultsSeats = parseInt(self.$form.find('input[name="transfer[adults]"]').val()) || 0;
      if (this.isHourly()) {
        if (!isHourlyDateValid()) setInputError($date_end.add($time_end));
      } else {
        if (!TransferForm.getDate()) setInputError($date_to);
        if (!is_date_return_valid()) setInputError($inputs_return);
      }

      if (!self.checkRequiredFields() || !self.allErrorsShowHide()) {
        valid = false;
      }

      if (self.currentTransferType() !== 'delivery' && adultsSeats < 1) {
        window.dispatchEvent(new CustomEvent('seatsFields.error'));
        valid = false;
      }

      const $phone = this.$form.find('#phone');

      if ($phone.length && $phone.val() && !Functions.isValidIntlPhone('phone')) {
        valid = false;
      }

      if (!transportTypePresenceCheck()) valid = false;

      if (!valid || $(`.${ERROR_CLASS}`).length) {
        event.target.submitting = false;
        $(`.${ERROR_CLASS}`).eq(0).focus();
        return event.preventDefault();
      }

      Functions.convertDate(this.$form.find('#date'))
      if (this.$form.find('#date_return').val()) {
        Functions.convertDate(this.$form.find('#date_return'))
      }
    });

    function isInputValid(input, validationMethod) {
      if (input.hasClass(ERROR_CLASS) && validationMethod) {
        input.removeClass(ERROR_CLASS);
        self.$form[0].submitting = false;
      }
    }

    window.addEventListener(self.EVENT_ROUTE_UPDATED, () => {
      const isDateToOk = TransferForm.isDateToOk;

      this.clearInputErrors();

      if ($date_to.val() && $time_to.val() && isDateToOk === false) {
        $time_to.addClass(ERROR_CLASS);
      }
      if (isDateToOk !== false) {
        isInputValid($time_to, true);
      }
      if ($date_to.hasClass(ERROR_CLASS)) {
        isInputValid($date_to, TransferForm.getDate());
      }
      if ($date_end.hasClass(ERROR_CLASS)) {
        isInputValid($date_end, isHourlyDateValid());
      }
      if ($time_end.hasClass(ERROR_CLASS)) {
        isInputValid($time_end, isHourlyDateValid());
      }
    })

    $inputs_return.blur(() => {
      isInputValid($inputs_return, is_date_return_valid());
    });
  },

  returnWayShowHide: function() {
    var self = this,
        $dateReturnBlock = $('#date_return_block'),
        $inputs = $dateReturnBlock.find('input'),
        $flightReturnBlock = $('#flight_return_block')

    $('#return_way').on('change', function(event) {
      if ($(this).prop('checked')) {
        $inputs.attr('required', 'required');
        $dateReturnBlock.show(self.animationDuration);
        $flightReturnBlock.show(self.animationDuration)
      } else {
        $dateReturnBlock.hide(self.animationDuration);
        $inputs.val('').removeAttr('required');
        $flightReturnBlock.hide(self.animationDuration)
        $flightReturnBlock.find('input').val('')
      }

      self.$form.trigger('point_changed')
      MapRoutes.changeMetrics();
      if (event.originalEvent) self.calcMaxPrice();
    }).trigger('change');
  },

  calcMaxPrice: function() {
    var $passenger_offered_price_input = $('#passenger_offered_price_value'),
        passenger_offered_price = $passenger_offered_price_input.val(),
        isReturn = $('#return_way').prop('checked');

    $('#offered_price_roundtrip').toggleClass('hidden', !isReturn);
    if (passenger_offered_price) {
      passenger_offered_price = parseFloat(passenger_offered_price);
      if (isReturn)
        passenger_offered_price *= 2;
      else
        passenger_offered_price /= 2;
      $passenger_offered_price_input.val(passenger_offered_price.toFixed(2));
    }
  },

  changeTransferType: function() {
    // Variables
    var self = this,
        $dateReturnBlock = $('#date_return_block'),
        $durationBlock = $('#hourly_end_block'),
        $toBlock = $('#to_block'),
        $gmapTable = $('.gmap-table'),
        $hourlyReturnInputs = $('#new-transfer-form').find('#date_end, #time_end'),
        $dateToInputs = $('#date, #time'),
        $routeToVisibleInput = $('#to'),
        $routeToHiddenInput = $('#pointto'),
        $header_title = $('.header h1'),
        $hourlyOptions = $('#hourly-options'),
        $dropOffCheckBox = $hourlyOptions.find('#hourly-drop-off'),
        $routeOptions = $('#route-options'),
        $dateReturnCheckBox = $routeOptions.find('#return_way'),
        $flightReturnBlock = $('#flight_return_block'),
        $transferDateToLabels = $('#one-way-date-label, #one-way-time-label'),
        $flightInputs = $('#transport_type_helicopter, #transport_type_airplane')

    // Functions
    function changeHeaderTitle(key) {
      var old_height = $header_title.height();
      $header_title.text($header_title.data(key));
      var new_height = $header_title.height();
      $header_title.height(old_height);
      $header_title.animate({height: new_height}, 'fast', function() {
        $header_title.height('auto');
      });
    }
    function changeToHourly(animationDuration) {
      hideReturnBlock(animationDuration);
      $gmapTable.fadeOut(animationDuration);
      if (!$dropOffCheckBox.prop('checked')) hideToBlock(animationDuration);
      self.$form.addClass('hourly');
      $('.input-wrapper-to').hide(animationDuration);
      $hourlyReturnInputs.add($dateToInputs).attr({required: true});
      $durationBlock.add($hourlyOptions).show(animationDuration);
      $transferDateToLabels.hide(animationDuration).animate(animationDuration);
      toggleDelivery(false, animationDuration);
      changeHeaderTitle('hourly');
    }
    function changeToRoute(animationDuration) {
      $routeOptions.show(animationDuration);
      if (!$flightInputs.is(':checked')) $gmapTable.fadeIn(animationDuration);

      showToBlock(animationDuration);
      self.$form.removeClass('hourly');
      $('.input-wrapper-to').show(animationDuration);
      $hourlyReturnInputs.removeAttr('required').val(null);
      $dropOffCheckBox.prop('checked', false);
      $durationBlock.add($hourlyOptions).hide(animationDuration);
      $transferDateToLabels.show(animationDuration);
      toggleDelivery(false, animationDuration);
      changeHeaderTitle('one-way');
    }

    function changeToDelivery(animationDuration) {
      hideReturnBlock(animationDuration);
      showToBlock(animationDuration);
      self.$form.removeClass('hourly');
      $('.input-wrapper-to').show(animationDuration);
      $hourlyReturnInputs.removeAttr('required').val(null);
      $dropOffCheckBox.prop('checked', false);
      $durationBlock.add($hourlyOptions).hide(animationDuration);
      $transferDateToLabels.show(animationDuration);
      toggleDelivery(true, animationDuration);
      changeHeaderTitle('delivery');
    }
    function toggleDelivery(showDelivery, animationDuration) {
      const $transportTypesBlock = $('.search-transport-type, .table-transport-type-container');
      const $deliveryTransportTypes = $transportTypesBlock.filter('.delivery');
      const $notDeliveryTransportTypes = $transportTypesBlock.filter(':not(.delivery)');
      const $hiddenForDelivery = $('.hidden-for-delivery');
      if (showDelivery) {
        $deliveryTransportTypes.show(animationDuration);
        $notDeliveryTransportTypes.hide(animationDuration).find('input:checked').trigger('click');
        $hiddenForDelivery.hide(animationDuration);
        $hiddenForDelivery.find('input[type="checkbox"]').prop({ checked: false }).trigger('change');
      } else {
        $deliveryTransportTypes.hide(animationDuration).find('input:checked').trigger('click');
        $notDeliveryTransportTypes.show(animationDuration);
        $hiddenForDelivery.show(animationDuration);
      }
    }

    function hideToBlock(animationDuration) {
      $toBlock.hide(animationDuration);
      self.points.to.clear()
      $routeToVisibleInput.removeAttr('required');
      $routeToHiddenInput.data('show', false);
    }
    function showToBlock(animationDuration) {
      $toBlock.show(animationDuration);
      $routeToVisibleInput.attr({required: true});
      $routeToHiddenInput.data('show', true);
    }
    function hideReturnBlock(animationDuration) {
      $routeOptions.hide(animationDuration);
      $flightReturnBlock.hide(animationDuration).find('input').val('')
      $dateReturnBlock.find('input').val('').removeAttr('required');
      $dateReturnBlock.hide(animationDuration);
      if ($dateReturnCheckBox.prop('checked')) {
        $dateReturnCheckBox.prop('checked', false);
        self.calcMaxPrice();
      }
    }
    function setCurrentTransferType(animationDuration) {
      const type = self.currentTransferType();
      if (type === 'hourly') {
        changeToHourly(animationDuration);
      } else if (type === 'delivery') {
        changeToDelivery(animationDuration);
      } else {
        changeToRoute(animationDuration);
      }
      window.dispatchEvent(new CustomEvent('transfer_type_changed', { detail: type }))
    }

    // Initialize
    setCurrentTransferType(0);

    $('.switcher input').on('change', function(){
      setCurrentTransferType(self.animationDuration);
      self.$form[0].submitting = false;
      self.$form.trigger('transfer_type_changed')
    });

    $dropOffCheckBox.on('change', function(event) {
      $(this).prop('checked') ? showToBlock(self.animationDuration) : hideToBlock(self.animationDuration);
    });

    $flightInputs.on('change', function (animationDuration) {
      let type = 'fadeIn'
      if (this.checked || self.$form.hasClass('hourly')) type = 'fadeOut'
      const checkedInputsCount = $flightInputs.filter(':checked').length
      if (
        !this.checked && checkedInputsCount === 0 ||
        this.checked && checkedInputsCount === 1
      ) {
        $gmapTable[type](animationDuration)
      }

      self.updateRoute()
    })

    $('#asap_checkbox').on('change', function() {
      if ($(this).prop('checked')) {
        $dateToInputs.val('').removeAttr('required').attr({disabled: true})
        hideReturnBlock(self.animationDuration);
      } else {
        $dateToInputs.removeAttr('disabled').attr({required: true})
        if (self.currentTransferType() === 'one_way') {
          $routeOptions.show(self.animationDuration);
        }
      }
    })
  },

  changeCurrencyEvent: function() {
    var self = this
    $('#menu-currency .drop-menu-item').on('click', function (event) {
      event.preventDefault()
      var value = $(this).data('value')
      $('.input-currency-select').val(value)
      Functions.setSetting('currency', value, () => self.updateRoute())
    })
  },

  swapLocations: function() {
    $('#swap-locations').on('click', () => {
      let tempPoints = { from: {}, to: {} };

      ['from', 'to'].forEach(key => {
        tempPoints[key]['text'] = this.points[key].text
        tempPoints[key]['place_id'] = this.points[key].place_id
        this.points[key].clear()
      });

      ['text', 'place_id'].forEach(key => {
        this.points.from[key] = tempPoints.to[key]
        this.points.to[key] = tempPoints.from[key]
      });
    });

    /**
     * Show/hide swap button on inputs change
     */

    var $inpFrom = $('#from');
    var $inpTo = $('#to');
    var $swapButton = $('#swap-locations');
    var $transferType = $('input[name=\'transfer_type\']');
    var isFromFieldFocused = false;

    function toggleSwapButton() {
      if (isFromFieldFocused) {
        $swapButton.removeClass('is-visible');
        return;
      }
      var fromVal = $inpFrom.val();
      var toVal = $inpTo.val();
      var transferTypeVal = $transferType.filter(':checked').val();

      var isShowButton = false;

      if ((fromVal || toVal) && transferTypeVal !== 'hourly') {
        isShowButton = true;
      }

      $swapButton.toggleClass('is-visible', isShowButton);
    }

    $inpFrom.add($inpTo).on('input change', toggleSwapButton);
    $inpFrom.on('focus', ()=> {
      isFromFieldFocused = true;
      toggleSwapButton();
    })
    $inpFrom.on('blur', () => {
      isFromFieldFocused = false;
      toggleSwapButton();
    })
    $transferType.on('change', toggleSwapButton);

    toggleSwapButton();
  },

  allErrorsShowHide: function() {
    var $pointTransferArr = $('.pointTransfer');
    var value = true;

    $.each($pointTransferArr, function(i, item) {

      var $input = $(this).parent().find('.inputTransferPoint');
      if (!$.trim(item.value) || !$.trim($input.val())) {

        if ($input.attr('required')) {
          value = false;
          $input.addClass('show-error');
        } else {
          $input.removeClass('show-error');
        }

      } else {
        $input.removeClass('show-error');
      }
    });

    return value;
  },

  getDate: function() {
    if ($('#asap_checkbox').prop('checked')) {
      return moment().toDate();
    } else {
      return Functions.inputDateTime($('#date'), $('#time'));
    }
  },

  getDateReturn: function() {
    return Functions.inputDateTime($('#date_return'), $('#time_return'))
  },

  getHourlyDateEnd: function() {
    return Functions.inputDateTime($('#date_end'), $('#time_end'))
  },

  setTransportTypesPrices: function(prices) {
    var self = TransferForm;
    var $transport_types = self.transportTypesElements();
    self.bookNowTypes = [];
    if ($transport_types.length === 0) return;

    if (!prices) {
      $transport_types.each(function() {
        self.hideTransportTypePrice($(this));
      });
      return;
    }

    $transport_types.each(function() {
      var $transport_type = $(this);
      var transportType = $transport_type.data('transportTypeId');
      var transport_type_data = prices[transportType];
      if (transport_type_data) {
        if (transport_type_data.book_now) {
          self.bookNowTypes.push(transportType);
        }

        $transport_type.find('.min-price span').text(transport_type_data['min'])
        $transport_type.find('.min-price').show();
      } else {
        self.hideTransportTypePrice($transport_type);
      }
    });
  },

  hideTransportTypePrice: function($transport_type) {
    $transport_type.find('.min-price').hide();
  },

  transportTypesElements: function() {
    if (TransferForm.$form.attr('id') === 'new-transfer-form') {
      return $('.table-transport-type tr td.price-cell label');
    } else {
      return $('.search-transport-type li');
    }
  },

  skipIframeOnShortForm () {
    if (this.$form.attr('skip-full-form') !== 'true') return;

    this.$form.submit(e => {
      e.preventDefault();
      const removedParams = $('[name="iframe"], [name="iframe_skin"], [name="partner_url"]').serialize();
      window.parent.location.href = `${this.$form.attr('action')}?${this.$form.serialize().replace(removedParams, '')}`;
    });
  },

  carRental: function() {
    const formType = this.formId === 'short-transfer-form' ? 'first_page' : 'second_page';
    let data = { utm_medium: formType };

    const date = moment(this.getDate()).locale('en');
    if (date) {
      let dateReturn = this.getDateReturn() && moment(this.getDateReturn()).locale('en');
      if (!dateReturn) dateReturn = date.add(this.CAR_RENTAL_DAYS_DURATION, 'days');

      data = {
        ...data,
        pt: date.format('hhmmA'),
        pd: date.format('YYYYMMDD'),
        dt: dateReturn.format('hhmmA'),
        dd: dateReturn.format('YYYYMMDD'),
      };
    }
    if (this.points.from.placeFrom) data.pl = this.points.from.placeFrom;
    try {
      gtag('event', 'autorentals_link', { event_label: this.points.from.country || 'no point' });
    } catch (e) {}

    const link = `${this.DEFAULT_CAR_RENTAL_LINK}&${$.param(data)}`;
    window.open(link, '_blank')
  },
};
